package uz.ferro.erp.feature.product.ui

import HeaderTitleView
import kotlinx.browser.window
import kotlinx.coroutines.MainScope
import kotlinx.coroutines.launch
import mui.icons.material.CheckCircleOutlineOutlined
import mui.icons.material.HighlightOffOutlined
import mui.icons.material.NetworkCell
import mui.icons.material.Speed
import mui.icons.material.WifiTethering
import mui.material.Box
import mui.material.Button
import mui.material.ButtonVariant
import mui.material.Card
import mui.material.CircularProgress
import mui.material.Dialog
import mui.material.DialogActions
import mui.material.DialogContent
import mui.material.DialogTitle
import mui.material.Divider
import mui.material.Grid
import mui.material.Paper
import mui.material.Size
import mui.material.SvgIconProps
import mui.system.responsive
import mui.system.sx
import react.FC
import react.create
import react.router.useParams
import react.useContext
import react.useEffect
import react.useEffectOnce
import react.useState
import uz.ferro.erp.AppContext
import uz.ferro.erp.Colors
import uz.ferro.erp.NavigationContext
import uz.ferro.erp.feature.auth.LoginDialog
import uz.ferro.erp.feature.country.model.Country
import uz.ferro.erp.feature.order.data.OrderRepository
import uz.ferro.erp.feature.order.model.OrderStatus
import uz.ferro.erp.feature.product.data.ProductManager
import uz.ferro.erp.feature.product.model.Product
import uz.ferro.erp.feature.product.utils.flagUrl
import uz.ferro.erp.feature.product.utils.getDataLimit
import uz.ferro.erp.feature.product.utils.getNetworkShort
import uz.ferro.erp.feature.product.utils.getValidityDays
import uz.ferro.erp.feature.product.utils.hasCalls
import uz.ferro.erp.feature.product.utils.hasData
import uz.ferro.erp.feature.product.utils.hasSMS
import uz.ferro.erp.feature.product.utils.hotspotEnabled
import uz.ferro.erp.feature.product.utils.speedLimit
import uz.ferro.erp.feature.user.model.User
import uz.ferro.erp.manager.AuthManager
import uz.ferro.erp.navigator.NavigationPage
import uz.ferro.erp.feature.alert.AlertManagerContext
import uz.ferro.erp.ui.AppText
import uz.ferro.erp.ui.AppTextMedium
import uz.ferro.erp.ui.GenericPage
import uz.ferro.erp.ui.HorizontalLayout
import uz.ferro.erp.ui.ImageView
import uz.ferro.erp.ui.VerticalLayout
import uz.ferro.erp.util.formatLocalCurrency
import uz.ferro.erp.util.lg
import uz.ferro.erp.util.localized
import uz.ferro.erp.util.md
import uz.ferro.erp.util.sm
import uz.ferro.erp.util.xs
import web.cssom.AlignItems
import web.cssom.JustifyContent
import web.cssom.Overflow
import web.cssom.pct
import web.cssom.px
import web.cssom.vh

private data class DetailsItem(
    var icon: FC<SvgIconProps> = FC {},
    var title: String = "",
    var value: String = ""
)

val ProductDetailsPage = FC {
    val pathParam = useParams()["productId"] ?: return@FC
    val productId = pathParam.toLongOrNull()
    var showPurchaseDialog by useState(false)
    var orderProgress by useState(false)
    val appContext = useContext(AppContext)
    var alertManager = useContext(AlertManagerContext)
    var navigator = useContext(NavigationContext)
    var product by useState(Product())
    var currentUser: User? by useState(AuthManager.user)

    useEffectOnce {
        window.scroll(0.0, 0.0)
    }

    var details by useState(
        listOf(
            DetailsItem(
                icon = NetworkCell,
                title = "Tarmoq",
                value = "4G/LTE"
            )
        )
    )

    var currentTab by useState("0")
    var countries by useState(listOf<Country>())

    var authDialogShown by useState(false)

    suspend fun loadData() {
        // investigate multiple load

        if (productId == null || product.id == productId) {
            return
        }

        try {
            val p = ProductManager.getProduct(productId)
            product = p
            countries = p.countries.orEmpty().mapNotNull { it.country }.sortedBy { it.name.localized() }

            details = listOf()
        } catch (e: Exception) {
        }
    }

    useEffect(productId) {
        MainScope().launch {
            loadData()
        }
    }

    GenericPage {
        if (productId == null || (product.id != null && product.disabled)) {
            HorizontalLayout {
                sx {
                    justifyContent = JustifyContent.center
                    color = Colors.textPrimary
                    fontSize = 24.px
                }
                +"Mahsulot topilmadi :("
                Box {
                    sx {
                        minHeight = 400.px
                    }
                }
            }
        } else if (product.id != null) {
            topFullWidthChildren = HeaderTitleView.create {
                this.title = product.title.localized()
            }

            Card {
                sx {
                    padding = 12.px
                    borderRadius = 12.px
                }
                VerticalLayout {
                    HorizontalLayout {
                        sx {
                            justifyContent = JustifyContent.spaceAround
                            marginTop = 8.px
                        }

                        VerticalLayout {
                            sx {
                                alignItems = AlignItems.center
                            }

                            AppText {
                                text = "Muddati"
                                color = Colors.textSecondary
                            }

                            AppTextMedium {
                                text = "${product.getValidityDays()} kun"
                                size = 20
                                color = Colors.accentColor
                            }
                        }

                        VerticalLayout {
                            sx {
                                alignItems = AlignItems.center
                            }

                            AppText {
                                text = "Internet"
                                color = Colors.textSecondary
                            }

                            AppTextMedium {
                                text = product.getDataLimit()
                                size = 20
                                color = Colors.accentColor
                            }
                        }

                        VerticalLayout {
                            sx {
                                alignItems = AlignItems.center
                            }

                            AppText {
                                text = "Narxi"
                                color = Colors.textSecondary
                            }

                            AppTextMedium {
                                text = product.localSellingPrice.formatLocalCurrency()
                                size = 20
                                color = Colors.accentColor
                            }
                        }
                    }
                }
            }

            HorizontalLayout {
                sx {
                    marginTop = 16.px
                    justifyContent = JustifyContent.center
                }
                Button {
                    sx {
                        width = 100.pct
                        maxWidth = 360.px
                        borderRadius = 50.vh
                        backgroundColor = Colors.accentColor
                    }
                    size = Size.large
                    variant = ButtonVariant.contained
                    onClick = {
                        if (AuthManager.isAuthorized()) {
                            showPurchaseDialog = true
                        } else {
                            authDialogShown = true
                        }
                    }
                    +"Harid qilish"
                }
            }

            AppTextMedium {
                text = "Qo‘shimcha ma’lumotlar"
                size = 20
                sx {
                    marginTop = 24.px
                }
            }


            Paper {
                sx {
                    borderRadius = 12.px
                    marginTop = 8.px
                }

                HorizontalLayout {
                    sx {
                        justifyContent = JustifyContent.spaceAround
                        marginTop = 8.px
                        padding = 12.px
                    }

                    VerticalLayout {
                        sx {
                            alignItems = AlignItems.center
                        }

                        if (product.hasData()) {
                            CheckCircleOutlineOutlined {
                                htmlColor = Colors.greenHex
                            }
                        } else {
                            HighlightOffOutlined {
                                htmlColor = Colors.errorColorHex
                            }
                        }

                        AppTextMedium {
                            text = "Internet"
                        }
                    }

                    VerticalLayout {
                        sx {
                            alignItems = AlignItems.center
                        }

                        if (product.hasCalls()) {
                            CheckCircleOutlineOutlined {
                                htmlColor = Colors.greenHex
                            }
                        } else {
                            HighlightOffOutlined {
                                htmlColor = Colors.errorColorHex
                            }
                        }

                        AppTextMedium {
                            text = "Qo‘ng‘iroqlar"
                        }
                    }

                    VerticalLayout {
                        sx {
                            alignItems = AlignItems.center
                        }

                        if (product.hasSMS()) {
                            CheckCircleOutlineOutlined {
                                htmlColor = Colors.greenHex
                            }
                        } else {
                            HighlightOffOutlined {
                                htmlColor = Colors.errorColorHex
                            }
                        }

                        AppTextMedium {
                            text = "SMS"
                        }
                    }
                }

                Divider {
                    sx {
                        borderBottomWidth = 1.5f.px
                        borderColor = Colors.headerDivider
                    }
                }

                Box {
                    sx {
                        padding = 12.px
                    }
                    Grid {
                        container = true
                        spacing = responsive(20.px)

                        details.forEach { detail ->
                            Grid {
                                item = true
                                xs = 12
                                sm = 6

                                HorizontalLayout {
                                    space = 16.px
                                    sx {
                                        alignItems = AlignItems.center
                                    }

                                    detail.icon {
                                        htmlColor = Colors.iconPrimary
                                    }

                                    VerticalLayout {
                                        space = 4.px
                                        AppText {
                                            size = 14
                                            text = detail.title
                                        }

                                        AppText {
                                            text = detail.value
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }

            AppTextMedium {
                text = "Mamlakatlar"
                size = 20
                sx {
                    marginTop = 24.px
                }
            }

            Box {
                sx {
                    marginTop = 8.px
                }
                Paper {
                    sx {
                        padding = 12.px
                        borderRadius = 12.px
                    }

                    Grid {
                        container = true
                        spacing = responsive(20.px)

                        countries.forEach { country ->
                            Grid {
                                item = true
                                xs = 12
                                sm = 6
                                md = 4
                                lg = 3

                                HorizontalLayout {
                                    space = 12.px
                                    sx {
                                        alignItems = AlignItems.center
                                    }

                                    Box {
                                        sx {
                                            width = 24.px
                                            height = 24.px
                                            borderRadius = 50.vh
                                            overflow = Overflow.hidden
                                        }

                                        ImageView {
                                            sx {
                                                width = 100.pct
                                                height = 100.pct
                                            }
                                            url = country.flagUrl()
                                        }
                                    }

                                    AppText {
                                        text = country.name.localized()
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    fun closePurchaseDialog() {
        if (orderProgress) return
        showPurchaseDialog = false
    }

    LoginDialog {
        isOpen = authDialogShown
        onClose = {
            authDialogShown = false
        }
        onLoginSuccess = {
            currentUser = AuthManager.user
            showPurchaseDialog = true
        }
    }

    Dialog {
        open = showPurchaseDialog
        fullWidth = true
        disableEscapeKeyDown = true
        onClose = { _, _ ->
            closePurchaseDialog()
        }
        DialogTitle {
            +"Buyurtmani tasdiqlaysizmi?"
        }

        DialogContent {
            Box {
                HorizontalLayout {
                    space = 8.px
                    AppText {
                        color = Colors.textSecondary
                        text = "Mahsulot: "
                    }
                    AppTextMedium {
                        text = product.title.localized()
                    }
                }

                HorizontalLayout {
                    space = 8.px
                    AppText {
                        color = Colors.textSecondary
                        text = "Narxi: "
                    }
                    AppTextMedium {
                        text = product.localSellingPrice.formatLocalCurrency()
                    }
                }

                HorizontalLayout {
                    space = 8.px
                    AppText {
                        color = Colors.textSecondary
                        text = "Foydalanuvchi: "
                    }

                    VerticalLayout {
                        AppTextMedium {
                            text = currentUser?.username
                        }
                        AppTextMedium {
                            text = currentUser?.fullName()
                        }
                    }
                }

                if (orderProgress) {
                    VerticalLayout {
                        sx {
                            marginTop = 24.px
                            alignItems = AlignItems.center
                        }
                        CircularProgress()
                    }
                }
            }
        }

        DialogActions {
            Button {
                disabled = orderProgress
                onClick = {
                    closePurchaseDialog()
                }
                +"Bekor"
            }

            Button {
                disabled = orderProgress || currentUser == null
                onClick = {
                    MainScope().launch {
                        orderProgress = true
                        try {
                            val order = OrderRepository.orderProduct(product)

                            if (order.status == OrderStatus.NEW) {
                                OrderRepository.reserveOrder(order.id!!)
                            }

                            navigator.openPage(NavigationPage.ORDER_LIST)
                            navigator.openPage(NavigationPage.ORDER_DETAILS, order.id!!)

                            closePurchaseDialog()
                        } catch (e: Exception) {
                            alertManager.handleError(e)
                            console.error(e)
                        }
                        orderProgress = false
                    }
                }
                +"Buyurtma Berish"
            }
        }
    }
}